import styled from "@emotion/styled";
import { AnimatePresence, motion } from "framer-motion";
import React, {
  PropsWithChildren,
  ReactNode,
  useEffect,
  useState,
} from "react";
import ArrowDownIcon from "../assets/icon/arrow-down";
import { notSelect } from "../styles/general";

interface IAccordionItem {
  id: string;
  isOpen: boolean;
  handleToggle: (id: string) => void;
  headerStyle?: React.CSSProperties;
  containerStyle?: React.CSSProperties;
  childContainerStyle?: React.CSSProperties;
  title: ReactNode;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-bottom: 1px solid #eaeaea;
  background-color: white;
`;

const Header = styled.div<{ isOpen: boolean }>`
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 0px 24px;
  height: 58px;
  align-items: center;
  color: #3e3e3e;
  font-weight: 600;
  cursor: pointer;
  ${notSelect}
  :hover {
    background-color: ${(props) => (props.isOpen ? "#fff" : "#f7f7f7")};
  }

  :nth-child(2) {
    height: 20px;
  }
`;
const HeaderTitle = styled.div`
  display: flex;
`;
const HeaderIcon = styled.div<{ isOpen: boolean }>`
  display: flex;

  transform: rotate(0deg);
  transition: 0.3s;

  ${(props) =>
    props.isOpen &&
    `    transform: rotate(180deg);
    `}
`;

const ChildContainer = styled(motion.div)<{ isOpen: boolean }>`
  width: 100%;
  overflow: hidden;
  padding: ${(props) => (props.isOpen ? "0px 45px 20px 45px" : "0px")};
`;

export default function AccordionItem(
  props: PropsWithChildren<IAccordionItem>
) {
  const {
    children,
    handleToggle,
    isOpen,
    headerStyle,
    containerStyle,
    title,
    childContainerStyle,
  } = props;

  const [isOpenTimedOut, setIsOpenTimedOut] = useState(isOpen);

  useEffect(() => {
    setTimeout(() => {
      setIsOpenTimedOut(isOpen);
    }, 50);
  }, [isOpen]);

  return (
    <Container id={props.id} style={containerStyle}>
      <Header
        onClick={() => handleToggle(props.id)}
        isOpen={isOpen}
        style={headerStyle}
      >
        <HeaderTitle>{title}</HeaderTitle>
        <HeaderIcon isOpen={isOpen}>
          <ArrowDownIcon height={15} width={15} color="#868482" />
        </HeaderIcon>
      </Header>
      <AnimatePresence>
        {isOpenTimedOut && (
          <ChildContainer
            style={childContainerStyle}
            key={props.id}
            initial={{ height: 0 }}
            animate={{
              height: "auto",
              transition: {
                duration: 0.05,
              },
            }}
            isOpen={isOpenTimedOut}
          >
            {children}
          </ChildContainer>
        )}
      </AnimatePresence>
    </Container>
  );
}
